import { getJson } from "../../auth/utils/getJson.js"; 

/** GET /api/filelogs?startDate=...&endDate=... (statusView=Fail|Pass omitted for All) */
export function fetchIncomingFiles({ start, end, statusView }, signal) {
  const params = new URLSearchParams();
  if (start) params.set('startDate', start);
  if (end) params.set('endDate', end);
  if (statusView && statusView !== 'All') params.set('statusView', statusView);
  params.set('_', Date.now()); 

  return getJson(`/api/filelogs?${params.toString()}`, { signal }).then((json) =>
    Array.isArray(json) ? json : []
  );
}
